import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "TABLE OF NUCLIDES"
const scope = "企画, VR空間体験設計・制作"
const str1 = "原子核物理学で用いられる、X軸に中性子数、Y軸に陽子数、Z軸に核子あたりの結合エネルギーを取った3次元の図をVR空間化した。"
const str2 = "この世界にはさまざまな学問のさまざまな図表があるが、空間化することで、その上を歩き、思索し、議論をすることが可能となる。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.nuclides01.childImageSharp.original.src}
          pageimgw={data.nuclides01.childImageSharp.original.width}
          pageimgh={data.nuclides01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/nuclides01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/nuclides02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/nuclides03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/nuclides04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/nuclides05.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  nuclides01: file(relativePath: {eq: "nuclides01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
